<template>
    <div :class="isMobile ? '' : 'container'" style="margin: auto">
        <h5 class="titol bold" v-show="false">
            {{ $t("s4_acc_opt_variants") }}
        </h5>

        <!-- ------------------------ -->
        <!-- Configuration parameters -->
        <!-- ------------------------ -->
        <div class="card my-3">
            <div class="card-header zindex_header">
                <strong>{{ $t("s4_config_resume") }}:</strong>
            </div>

            <div
                class="card-body d-flex"
                :class="[
                    (window.innerWidth > 1200 &&
                        !gama_66_67_is_horizontal &&
                        numMainElements < 5) ||
                    (window.innerWidth > 1200 && numMainElements < 3)
                        ? 'flex-row'
                        : 'flex-column',
                ]"
            >
                <div class="my-2" :class="isMobile ? 'mr-1' : 'mr-5'">
                    <p
                        class="text-left"
                        v-for="parameter in app.currentConfiguration
                            .familyParameters"
                        :key="parameter.attribute.id"
                    >
                        <span class="bold">{{ parameter.attribute.name }}</span>
                        : {{ parameter.valueString }}
                    </p>
                    <template
                        v-if="
                            !b66b67helper.is66or67() ||
                            b66b67helper.isTramoComun()
                        "
                    >
                        <p
                            class="text-left"
                            v-for="parameter in app.currentConfiguration
                                .commonMainElementParameters"
                            :key="parameter.attribute.id"
                        >
                            <span class="bold">{{
                                parameter.attribute.name
                            }}</span>
                            : {{ parameter.valueString }}
                        </p>
                    </template>
                </div>

                <div v-if="false">
                    <h2 @click="app.getScreenshotMainElement()">
                        Captured image (click to refresh)
                    </h2>
                    <img
                        :src="app.currentConfiguration.mainElementsImage"
                        style="max-width: 100%; height: auto"
                        @click="app.getScreenshotMainElement()"
                    />
                </div>
                <div
                    id="main-elements"
                    ref="div_main_elements"
                    class="mt-2 no-print"
                    :class="[
                        numMainElements > 3 && gama_66_67_is_horizontal
                            ? 'zoom_numElements_major3_i_horitz'
                            : '',
                    ]"
                >
                    <main-elements66simetric-component
                        v-if="
                            idsolucionconstructiva == '10-t_sop' &&
                            idgama == '66'
                        "
                        ref="refmainElements66SimetricComponent"
                        :prop_readonly="true"
                    />

                    <main-elements66-component
                        v-if="
                            idsolucionconstructiva !== '10-t_sop' &&
                            idgama == '66'
                        "
                        ref="refmainElements66Component"
                        :prop_readonly="true"
                        @ishorizontal="update_66_67_horizontal"
                    />

                    <main-elements67simetric-component
                        v-if="
                            idsolucionconstructiva == '10-t_sop' &&
                            idgama == '67'
                        "
                        ref="refmainElements67SimetricComponent"
                        :prop_readonly="true"
                    />

                    <main-elements67-component
                        v-if="
                            idsolucionconstructiva !== '10-t_sop' &&
                            idgama == '67'
                        "
                        ref="refmainElements67Component"
                        :prop_readonly="true"
                        @ishorizontal="update_66_67_horizontal"
                    />
                </div>
            </div>
        </div>

        <!-- --------------------------------------------- -->
        <!-- Elementos de acabado, opcionales y variantes: -->
        <!-- --------------------------------------------- -->
        <div class="card my-3 no-print">
            <div class="card-header zindex_header">
                <strong>{{ $t("s4_acc_opt_variants") }}:</strong>
            </div>

            <div
                v-for="(element, key, index) in app.currentConfiguration
                    .elements"
                :key="index"
            >
                <div @click="updateExpanded(index)"></div>
                <div
                    v-if="
                        typeof app.currentConfiguration.familyParameters.gama !=
                        'undefined'
                    "
                    class="card-header zindex_header"
                    :id="'id_' + key"
                >
                    <div
                        class="display:flex; flex-column justify-content-center"
                    >
                        <!-- titol header -->
                        <strong
                            ><p class="text-center">
                                {{ element.name }}
                            </p></strong
                        >

                        <div
                            v-if="
                                app.currentConfiguration.mainElementParameters[
                                    key
                                ] &&
                                Object.keys(
                                    app.currentConfiguration
                                        .mainElementParameters[key].length > 0
                                )
                            "
                        >
                            <div
                                v-for="parameter in app.currentConfiguration
                                    .mainElementParameters[key]"
                                :key="parameter.attribute.id"
                            >
                                <p
                                    class="text-left"
                                    v-if="
                                        !(
                                            b66b67helper.is66or67() &&
                                            (parameter.attribute.id ==
                                                'metros_por_tramo' ||
                                                parameter.attribute.id ==
                                                    'distancia_soportes') &&
                                            b66b67helper.isTramoComun() && b66b67helper.mustShowDistanciaEntreSoportes()
                                        ) &&
                                        !(
                                            parameter.attribute.id == 'metros_por_espacio_trabajo'
                                            && app.currentConfiguration.mainElementParameters[key]['guia']
                                            && app.currentConfiguration.mainElementParameters[key]['guia'].value
                                            && app.currentConfiguration.mainElementParameters[key]['guia'].value.id == 'sin_guia'
                                        ) &&
                                        !(
                                            idgama == '50t' &&
                                            parameter.attribute.id == 'numero_mecanismos' &&
                                            app.market.id =='chile'
                                        ) &&
                                        !(
                                            idgama == '50t' &&
                                            parameter.attribute.id == 'numero_placas' &&
                                            app.market.id !='chile'
                                        ) &&
                                        !(
                                            parameter.attribute.id == 'altura_trabajo' &&
                                            (app.currentConfiguration.familyParameters['sol_constructiva'].value.id == '70-rack-bottom' ||
                                                app.currentConfiguration.familyParameters['sol_constructiva'].value.id == '70-rack-h')
                                        ) &&
                                        !(
                                            parameter.attribute.id == 'altura_trabajo_rack' &&
                                            (app.currentConfiguration.familyParameters['sol_constructiva'].value.id == '70-t_tra' ||
                                                app.currentConfiguration.familyParameters['sol_constructiva'].value.id == '70-t_h')
                                        )
                                    "
                                >
                                    <span class="bold">{{
                                        parameter.attribute.name
                                    }}</span>
                                    : {{ parameter.valueString }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="card-body"
                    :style="
                        isMobile
                            ? 'padding-left:5px !important; padding-right:5px !important;'
                            : ''
                    "
                >
                    <form>
                        <!-- TABLE DESKTOP -->
                        <table
                            style="width: 100%"
                            v-show="expanded.includes(index)"
                            class="d-none d-lg-table"
                        >
                            <thead>
                                <tr>
                                    <th>
                                        <input
                                            type="checkbox"
                                            v-if="enableShowKits"
                                            v-model="showKits"
                                            name="showKits"
                                        />
                                        <label
                                            for="showKits"
                                            v-if="enableShowKits"
                                            >Mostrar Kits</label
                                        >
                                    </th>
                                    <th></th>
                                    <th class="text-center">
                                        {{ $t("s4_table_acc_piece_type") }}
                                    </th>
                                    <th class="text-center">
                                        {{ $t("s4_table_acc_description") }}
                                    </th>
                                    <th
                                        style="min-width: 120px"
                                        class="text-center"
                                    >
                                        {{ $t("s4_table_acc_quantity") }}
                                    </th>
                                    <th v-show="app.currentConfiguration.priceList.show_prices == 1"
                                        style="min-width: 120px"
                                        class="text-center"
                                    >
                                        {{ $t("s4_table_acc_price") }}
                                    </th>
                                    <th v-show="app.currentConfiguration.priceList.show_prices == 1"
                                        style="min-width: 120px"
                                        class="text-center"
                                    >
                                        {{ $t("s4_table_acc_total_price") }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <productElementComponent
                                    class=".d-none .d-sm-block"
                                    :element="element"
                                    :elementIndex="index"
                                    :showQuantities="true"
                                    :show="true"
                                    :forceShowKits="showKits"
                                    :level="0"
                                ></productElementComponent>
                            </tbody>
                        </table>

                        <!-- TABLE MOBILE-->
                        <table
                            v-show="expanded.includes(index)"
                            class="d-table d-lg-none"
                            width="100%"
                        >
                            <thead>
                                <tr>
                                    <!-- <th>{{ $t('s4_table_mobile_ref') }}</th> -->
                                    <th></th>
                                    <th>
                                        {{ $t("s4_table_mobile_quantity") }}
                                    </th>
                                    <th>{{ $t("s4_table_mobile_price") }}</th>
                                    <th>
                                        {{ $t("s4_table_mobile_total_price") }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <productElementMobileComponent
                                    :element="element"
                                    :elementIndex="index"
                                    :showQuantities="true"
                                    :show="true"
                                    :level="0"
                                    :forceShowKits="showKits"
                                ></productElementMobileComponent>
                            </tbody>
                        </table>
                    </form>
                </div>
            </div>
        </div>

        <!-- ------------------ -->
        <!-- Elementos comunes: -->
        <!-- ------------------ -->
        <div
            v-if="
                app.currentConfiguration.commonElements &&
                app.currentConfiguration.commonElements.childs.length > 0
            "
            class="card my-3 no-print"
        >
            <div class="card-header zindex_header">
                <strong>{{ $t("s4_titel_common_elements") }}:</strong>
            </div>

            <!-- S'acorda posar sempre aquest div encara que pugui no apareixer -->
            <div
                v-for="(element, key, index) in app.currentConfiguration
                    .commonElements.childs"
                :key="index"
            >
                <div @click="updateExpanded(index)"></div>

                <div
                    class="card-body"
                    :style="
                        isMobile
                            ? 'padding-left:5px !important; padding-right:5px !important;'
                            : ''
                    "
                >
                    <form>
                        <!-- TABLE DESKTOP -->
                        <table
                            v-show="expanded.includes(index)"
                            class="d-none d-lg-table"
                        >
                            <thead>
                                <tr>
                                    <th>
                                        <input
                                            type="checkbox"
                                            v-if="enableShowKits"
                                            v-model="showKits"
                                            name="showKits"
                                        />
                                        <label
                                            for="showKits"
                                            v-if="enableShowKits"
                                            >Mostrar Kits</label
                                        >
                                    </th>
                                    <th></th>
                                    <th
                                        class="
                                            leftmiddleIfPhone_centerMiddleIfPC
                                        "
                                    >
                                        {{ $t("s4_table_acc_piece_type") }}
                                    </th>
                                    <th
                                        class="
                                            leftmiddleIfPhone_centerMiddleIfPC
                                        "
                                    >
                                        {{ $t("s4_table_acc_description") }}
                                    </th>
                                    <th
                                        class="
                                            leftmiddleIfPhone_centerMiddleIfPC
                                        "
                                    >
                                        {{ $t("s4_table_acc_quantity") }}
                                    </th>
                                    <th
                                        class="
                                            leftmiddleIfPhone_centerMiddleIfPC
                                            hideIfPhone
                                        "
                                    >
                                        {{ $t("s4_table_acc_price") }}
                                    </th>
                                    <th
                                        class="
                                            leftmiddleIfPhone_centerMiddleIfPC
                                            hideIfPhone
                                        "
                                    >
                                        {{ $t("s4_table_acc_total_price") }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <productElementComponent
                                    class=".d-none .d-sm-block"
                                    :element="element"
                                    :elementIndex="index"
                                    :showQuantities="true"
                                    :show="true"
                                    :forceShowKits="showKits"
                                    :level="0"
                                ></productElementComponent>
                                <!-- :zoommedImage = zoommedImage -->
                                <!-- @updateZoomedImage = "updateZoomedImage" -->
                            </tbody>
                        </table>

                        <!-- TABLE MOBILE-->
                        <table
                            v-show="expanded.includes(index)"
                            class="d-table d-lg-none"
                            width="100%"
                        >
                            <thead>
                                <tr>
                                    <!-- <th>{{ $t('s4_table_mobile_ref') }}</th> -->
                                    <th class="header_width"></th>
                                    <th class="header_width">
                                        {{ $t("s4_table_mobile_quantity") }}
                                    </th>
                                    <th class="header_width">
                                        {{ $t("s4_table_mobile_price") }}
                                    </th>
                                    <th class="header_width">
                                        {{ $t("s4_table_mobile_total_price") }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <productElementMobileComponent
                                    :element="element"
                                    :elementIndex="index"
                                    :showQuantities="true"
                                    :show="true"
                                    :level="0"
                                    :forceShowKits="showKits"
                                ></productElementMobileComponent>
                            </tbody>
                        </table>
                    </form>
                </div>
            </div>
        </div>

        <!-- ------------------ -->
        <!-- ERRORES o ADVERTENCIAS -->
        <!-- ------------------ -->
        <div v-if="app.hasConfigurationErrors()" class="card my-3 no-print">
            <div class="card-header">
                <!-- TODO: vermell unex -->
                <i
                    class="fas fa-exclamation-triangle mr-2"
                    style="color: Red"
                ></i
                ><strong>{{ $t("s4_title_errors") }}</strong>
            </div>

            <div class="card-body">
                <div
                    v-for="(error, index) in app.getConfigurationErrors()"
                    :key="index"
                >
                    <div class="alert alert-danger" role="alert">
                        {{ error }}
                    </div>
                </div>
            </div>
        </div>

        <!-- -------------------------------------------------------
                                SHOW BOM
        ----------------------------------------------------------->
        <bomComponent
            v-if="!app.hasConfigurationErrors()"
            class="no-print"
        ></bomComponent>
        <!-- ---------------------------------------------------------- -->

        <!-- TECHNICAL FILES -->
        <technicalFilesComponent
            v-if="!app.hasConfigurationErrors()"
            class="no-print"
            :configuration="app.currentConfiguration">
        </technicalFilesComponent>
        <!-- -------------------------------------------------------
                                DOWNLOAD / eCOMMERCE
        ----------------------------------------------------------->
        <div v-if="!app.hasConfigurationErrors()" class="my-4 no-print">
            <!-- ------------------------------------------
                        SHOPPING CART
            -------------------------------------------->
            <div v-if="app.WholeSaler.isWholeSaler">
                <send-to-whole-saler></send-to-whole-saler>
            </div>

            <div v-if="app.auth.enabled">
                <!-- ------------------------------------------
                        DOWNLOAD BOM
                -------------------------------------------->
                <downloads-component></downloads-component>
                <!-- ------------------------------------- -->
            </div>
            <div v-else></div>
        </div>

        <!-- diagnostics -->
        <diagnostics-component />

        <!-- -------------------------------------------------------
                                NAVIGATION
        ----------------------------------------------------------->
        <div
            class="d-flex flex-column justify-content-center align-items-center"
        >
            <button
                type="button"
                class="btn btn-dark mt-5 text-center btn_bottom"
                @click="app.navigateToStageAsync('1')"
            >
                <i class="fas fa-plus mr-2"></i>
                {{ $t("new_configuration_btn") }}
            </button>

            <button
                type="button"
                class="btn btn-outline-secondary mt-3 text-center btn_bottom"
                @click="navigateToLastStage()"
            >
                <i class="fas fa-backward"></i>
            </button>
        </div>
    </div>
</template>

<style scoped lang="scss">
@media print {
    .no-print,
    .no-print * {
        display: none !important;
    }
}
.header_width {
    min-width: 30px;
}

.zindex_header {
    z-index: 997;
}

.margin_bottom_results {
    margin-bottom: 200px;
}

.zoom_numElements_major3_i_horitz {
    zoom: 0.75;
}

.bandeja-66-item-box {
    width: 200px;
    height: 200px;
    // float: left;
    // clear: none;
    // position: relative;
    // overflow: hidden;
}

.bandeja-66-row {
    height: 200px;
    // overflow: hidden;
}

@media screen and (max-width: 480px) {
    .bandeja-66-grid {
        zoom: 0.75;
    }
}

@media screen and (max-width: 330px) {
    .bandeja-66-grid {
        zoom: 0.69;
    }
}
#main-elements {
    background: White;
}
.left_params_bandeja_col1 {
    position: absolute;
    left: 80px;
}

.left_params_bandeja_col2 {
    position: absolute;
    left: 235px;
}

.left_params_bandeja_col1_mobile {
    position: absolute;
    left: 80px;
}

.left_params_bandeja_col2_mobile {
    position: absolute;
    left: 235px;
}

.bandeja-66-techo {
    background-image: url("../../assets/images/gamas/66/pared_20x200.png");
    background-repeat: repeat-y;
    height: 400px;
    position: absolute;
    width: 20px;
    top: -210px;
    left: 190px;
    transform: rotate(90deg);
    z-index: 500;
}
.bandeja-66-techo-mobile {
    background-image: url("../../assets/images/gamas/66/pared_20x200.png");
    background-repeat: repeat-y;
    height: 400px;
    position: absolute;
    width: 20px;
    top: -210px;
    left: 190px;
    transform: rotate(90deg);
    z-index: 500;
}

.bandeja-66-perfil {
    background-image: url("../../assets/images/gamas/66/perfil_pared_20x200.png");
    background-repeat: repeat-x;
    height: 200px;
    position: absolute;
    width: 20px;
    left: 190px;
    transform: rotate(0deg);
    z-index: 500;
}
.bandeja-66-perfil-mobile {
    background-image: url("../../assets/images/gamas/66/perfil_pared_20x200.png");
    background-repeat: repeat-x;
    height: 200px;
    position: absolute;
    width: 20px;
    left: 190px;
    transform: rotate(0deg);
    z-index: 500;
}

.selected_img {
    display: block !important;
}

.leftmiddleIfPhone_centerMiddleIfPC {
    text-align: center;
    vertical-align: middle;
}

.titol {
    text-align: left;
    margin-top: 50px;
    margin-bottom: 25px;
}
.bullet {
    width: 40px;
    height: 40px;
}
.text_green {
    color: lawngreen;
    font-weight: bold;
}
.bold {
    font-weight: bold;
}
.left {
    text-align: left;
}

.marginLeft {
    margin-left: 30px;
}
.bulletRotated {
    -ms-transform: rotate(90deg); /* IE 9 */
    -webkit-transform: rotate(90deg); /* Safari 3-8 */
    transform: rotate(90deg);
}
.estil_radio {
    width: 20px;
    height: 20px;
}
.estil_checkbox {
    width: 20px;
    height: 20px;
}

.btnCarroCompra {
    margin: 50px 30px 100px 30px;
}

@media (max-width: 767px) {
    .hideIfPhone {
        display: none;
        visibility: hidden;
    }
    .leftmiddleIfPhone_centerMiddleIfPC {
        text-align: left;
        vertical-align: middle;
    }
}
</style>


<script>
import { app } from "../../application.js";
import downloadsComponent from "./downloads.vue";
import productElementComponent from "./productElement.vue";
import sendToWholeSaler from "./sendToWholeSaler.vue";
import productElementMobileComponent from "./productElementMobile.vue";
import mainElements66simetricComponent from "../mainElement/mainElements66simetric.vue";
import mainElements67simetricComponent from "../mainElement/mainElements67simetric.vue";
import mainElements66Component from "../mainElement/mainElements66.vue";
import mainElements67Component from "../mainElement/mainElements67.vue";
import B66B67Helper from "../../services/b66b67helper.js";
import bomComponent from "./bom.vue";
import technicalFilesComponent from "./technicalFiles.vue";
// import { MultiLevel } from "@/services/multiLevel.js";
import html2canvas from 'html2canvas'
import diagnosticsComponent from "../common/diagnostics.vue";

export default {
    name: "resultsComponent",

    created() {


    },
    mounted(){
        app.currentConfiguration.stage = 4;
        // window.addEventListener("resize", this.handleResize);
        // this.handleResize();
        window.scrollTo(0, 0);

        this.idgama = app.currentConfiguration.familyParameters["gama"].value.id;
        this.idsolucionconstructiva = app.currentConfiguration.familyParameters["sol_constructiva"].value.id;

        if (app.env != 'prod') {
            this.enableShowKits = true;
        }
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },

    updated: async function () {

    },

    data() {
        return {
            app: app,
            bom_parameters: {},
            expanded: [],
            hoveredImage: "",
            direccionHorizontal: app.elementsImagesDireccionHorizontal,
            elementsImagesSize: app.elementsImagesSize,
            elementsImage_wall: app.elementsImage_wall,
            elementsImage_ceiling: app.elementsImage_ceiling,
            elementsImage_Floor: app.elementsImage_Floor,
            window: { width: 0, height: 0 },
            multiLevel: app.multiLevelHelper,
            enableShowKits: false,
            showKits: false,
            idgama: "",
            idsolucionconstructiva: "",
            gama_66_67_is_horizontal: false,
            b66b67helper: new B66B67Helper(app)
        };
    },

    methods: {
        update_66_67_horizontal: function (isHorizontal) {

            //console.warn('update_66_67_horizontal: ', isHorizontal);
            this.gama_66_67_is_horizontal = isHorizontal;

        },


        navigateToLastStage: function () {
            // TODO: Aixo no pot estar harcoded aquí!!!!!
            if (
                this.idgama === '77' ||
                this.idgama === '88' ||
                this.idgama === '07' ||
                this.idgama === '22-0' ||
                this.idgama === '22' ||
                this.idgama === '22hd' ||
                this.idgama === '22-1' ||
                this.idgama === '22dt'
            ) {
                app.navigateToStageAsync('2')
            } else {
                app.navigateToStageAsync('3')
            }
        },

        screenshot: async function (element) {

            try {
                var canvas = await html2canvas(element);
                var png = canvas.toDataURL()

                return png;

            } catch (error) {
                console.warn('error html2canvas: ', error);
            }
        },

        screenshot_images_mainElements: async function () {

            try {
                if (this.idgama == '66' || this.idgama == '67') {

                    let mainElementsImage =
                        await this.screenshot(this.$refs.div_main_elements);

                    this.app.currentConfiguration.mainElementsImage = mainElementsImage;

                    await this.app.asyncProcess(false, false);

                    return true;
                }

            } catch (error) {
                //console.log('screenshot_images_mainElements error: ', error);
                return false;
            }

        },

        getMainElement(row, col) {
            return this.multiLevel.getElement(row, col);
        },
        handleResize() {
            // this.window.width = window.innerWidth;
            // this.window.height = window.innerHeight;
        },
        mouseoverImgScreen3: function (key_elementsImages) {
            this.hoveredImage = key_elementsImages;
        },
        mouseoutImgScreen3: function (key_elementsImages) {
            this.hoveredImage = "";
        },
        updateExpanded: function (index) {
            if (this.expanded.includes(index)) {
                this.expanded = this.expanded.filter(item => item !== index);
            } else {
                this.expanded.push(index);
            }
        },

        toggleResume: function (event) {
            this.resumeIsActive = !this.resumeIsActive;
        },

        // showModal: function(idModalToShow, checkedProtectorTornillo) {
        //     console.log("idModalToShow: ", idModalToShow);
        //     // console.log(idModalToShow, checkedProtectorTornillo);
        //     // console.log(this.$refs[idModalToShow]);

        //     if (!checkedProtectorTornillo) {
        //         // this.$refs[idModalToShow].show();
        //         this.$refs[idModalToShow].show();
        //     }
        // },

        // hideModal: function(idModalToShow, checkedProtectorTornillo) {
        //     this.$refs[idModalToShow].hide();
        // },

        //nomes per si tira endarrera amb el navegador
        beforeRouteLeave(to, from, next) {
            //console.log("to.name: ", to.name);
            if (to.name !== "4") {
                let self = this;

                //Here the message could be stored in the app depending on the language
                let infoModal = {
                    modalToShow: "warnPageLeaveModal",
                    title: self.app.translate(
                        "popup_warn_changes_will_be_lost_titel"
                    ),
                    message: self.app.translate(
                        "popup_warn_changes_will_be_lost_message"
                    ),
                    html_message: "",
                    showConfirmationButton: true,
                    showCancelButton: true,
                    textConfirmationButton: self.app.translate(
                        "default_text_acceptbutton"
                    ),
                    textCancelButton: self.app.translate(
                        "default_text_cancelbutton"
                    )
                };

                self.app
                    .showModal(infoModal)
                    .then(({ userAction, paramResult }) => {
                        if (userAction === "modal_rejected") {
                            // console.log(
                            //     "navigationbar received modal_rejected"
                            // );
                            next(false);
                        } else if (userAction === "modal_confirmed") {
                            // console.log(
                            //     "navigationbar received modal_confirmed"
                            // );
                            // self.app.isSpinnerAlwaysVisible = true;
                            next(true);
                        }
                    });
            }
        }
    },
    computed: {
        numMainElements: function () {
            return Object.keys(this.app.currentConfiguration.mainElementParameters).length;
        },
        isMobile: function () {
            // let a = window.width < 1000;
            // return a;
            return app.isMobile()
        },

    },

    components: {
        downloadsComponent,
        sendToWholeSaler,
        bomComponent,
        productElementComponent,
        productElementMobileComponent,
        mainElements66simetricComponent,
        mainElements66Component,
        mainElements67simetricComponent,
        mainElements67Component,
        diagnosticsComponent,
        technicalFilesComponent
    }


};
</script>




